// extracted by mini-css-extract-plugin
module.exports = {"mainSignInWrapper":"signInBlock_mainSignInWrapper__33Lj5","singInWrapperMob":"signInBlock_singInWrapperMob__lZt1E","singInWrapper":"signInBlock_singInWrapper__38bij"};